import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function DictaminadorIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("dictaminador"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Dictaminador" breadcrumb={["Dictaminador", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="dictaminador" />
      </div>
    </AppLayout>
  );
}
